"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._realm = exports._domain = void 0;
var _domain;
(function (_domain) {
    _domain["dev"] = "dev";
    _domain["test"] = "test";
    _domain["alpha"] = "alpha";
    _domain["beta"] = "beta";
    _domain["gamma"] = "gamma";
    _domain["training"] = "training";
    _domain["staging"] = "staging";
    _domain["prod"] = "prod";
})(_domain || (exports._domain = _domain = {}));
var _realm;
(function (_realm) {
    _realm["USAmazon"] = "USAmazon";
    _realm["EUAmazon"] = "EUAmazon";
    _realm["FEAmazon"] = "FEAmazon";
})(_realm || (exports._realm = _realm = {}));
